import { render, staticRenderFns } from "./AccessStaffSlidebar.vue?vue&type=template&id=6c145d57"
import script from "./AccessStaffSlidebar.vue?vue&type=script&lang=js"
export * from "./AccessStaffSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports